// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var TicketReopen$ReactHooksTemplate = require("./ticketReopen.res.js");

function TicketReopenView(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: "Ticket Reopened",
                            className: "text-sm font-semibold"
                          }),
                      JsxRuntime.jsx("div", {
                            children: TicketReopen$ReactHooksTemplate.user_email(props.activity),
                            className: "text-xs font-normal"
                          })
                    ],
                    className: "flex justify-between text-darkcharcoal"
                  })
            });
}

var make = TicketReopenView;

exports.make = make;
/* react/jsx-runtime Not a pure module */
